import ContainerForgotPWEmail from "./Components/ContainerForgotPWEmail";
import ContainerForgotPWCode from "./Components/ContainerForgotPWCode";
import ContainerForgotPWReset from "./Components/ContainerForgotPWReset";
import { useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LiquidGlass from "../../Components/Style/LiquidGlass";
import HeroBG from "../../Components/Style/HeroBG";

export default function ForgotPW() {
  const [step, setStep] = useState("email");
  const navigate = useNavigate();
  const [recoveryData, setRecoveryData] = useState({
    email: "",
    code: "",
  });

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative flex justify-center items-center min-h-dvh bg-zi-bg1-light dark:bg-zi-bg1-dark p-4">
      <div className="absolute inset-0 z-0 transition-none">
        <HeroBG />
      </div>
      {step === "email" && (
        <LiquidGlass tag="div" rounded="3xl" className="rounded-3xl max-w-sm w-full flex z-10" childrenClassName="w-full">
          <ContainerForgotPWEmail
            text="فراموشی رمز عبور"
            onContinue={(email) => {
              setRecoveryData((previous) => ({ ...previous, email }));
              setStep("code");
            }}
            onBack={() => navigate("/signin")}
          />
        </LiquidGlass>
      )}
      {step === "code" && (
        <LiquidGlass tag="div" rounded="3xl" className="rounded-3xl max-w-sm w-full flex z-10" childrenClassName="w-full">
          <ContainerForgotPWCode
            email={recoveryData.email}
            onBack={() => setStep("email")}
            onContinue={(code) => {
              setRecoveryData((previous) => ({ ...previous, code }));
              setStep("reset");
            }}
          />
        </LiquidGlass>
      )}
      {step === "reset" && (
        <LiquidGlass tag="div" rounded="3xl" className="rounded-3xl max-w-sm w-full flex z-10" childrenClassName="w-full">
          <ContainerForgotPWReset
            text="تنظیم مجدد رمز عبور"
            onBack={() => setStep("code")}
          />
        </LiquidGlass>
      )}
    </div>
  );
}
